import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from "axios";

export default function PopularCategories() {
    const { t, i18n } = useTranslation();
    UseScrollAnimation();

    const [dataCategories, setCategories] = useState([]);
    const [visibleCount, setVisibleCount] = useState(6); 

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/categories");
                // Reverse the categories to show the latest one first
                setCategories([...response.data.category].reverse());
            } catch (error) {
                console.error("Error when fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const isShowingAll = visibleCount >= dataCategories.length;

    const toggleCategories = () => {
        if (isShowingAll) {
            setVisibleCount(6);
        } else {
            setVisibleCount(prevCount => Math.min(prevCount + 3, dataCategories.length)); 
        }
    };

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    return (
        <section className="relative py-[40px]">
            <div className="container">
                <div className="btmAni30002 direction-text-ar page-title mb-[20px]">
                    {t("Popular")} <span>{t("Categories")}</span>
                </div>
                <div className="flex flex-wrap items-center jsut-center gap-[20px]">
                    {dataCategories.slice(0, visibleCount).map((el, index) => {
                        const categoryName = getLocalizedText({
                            A: el.category_name_A,
                            E: el.category_name_E,
                        });
                        

                        return (
                            <Link
                                to={`/mainCategories/${el.category_name_E}`}
                                key={index}
                                className="flex flex-col items-center text-center"
                            >
                                <div className="back-category w-100-p h-100-p w-[125px] h-[125px] shadow-[0px_0px_10px_#0000000f] p-1.5 rounded-md flex items-center justify-center">
                                    <img
                                        className="w-[115px] h-[115px] object-contain"
                                            sizes="125px"
                                            width="125"
                                            height="125"
                                            loading="lazy"
                                            decoding="async"
                                            src={`https://laravel-api.aj-mart.com/storage/app/public/${el.category_img}`}
                                        alt={el.category_name_E}
                                    />
                                </div>
                                <div className="flex flex-col items-center text-center">
                                    <div className="font-13 text-[20px] font-bold">{categoryName}</div>
                                    <p className="text-[13px] text-[#666666]">
                                        {el.quantity} <span>{t("Products")}</span>
                                    </p>
                                </div>
                            </Link>
                        );
                    })}
                </div>
                <div className="text-center mt-5 flex items-center justify-center">
                    {dataCategories.length > 6 && (
                        <button
                            onClick={toggleCategories}
                            className="flex items-center justify-center my-[15px]"
                        >
                            <div className="btn">
                                {isShowingAll ? t("Show Less") : t("Show More")}
                            </div>
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}